<script setup>
import PackageForm from '@frontJs/components/forms/projectManagement/apikom/PackageForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const props = defineProps({
    package: {
        type: Object,
        required: false,
    },
    packageThemes: {
        type: Array,
        required: true,
    },
    packageFrequencies: {
        type: Array,
        required: true,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="props.package">
            Mettre à jour le forfait #{{ props.package.id }} - Forfaits - Apikom
            - Gestion de projet - Datakepler
        </title>

        <title v-else>
            Créer un forfait - Forfaits - Apikom - Gestion de projet -
            Datakepler
        </title>
    </Head>

    <PageTitle v-if="props.package">
        Gestion de projet - Apikom - Forfaits - Mettre à jour le forfait #{{
            props.package.id
        }}
    </PageTitle>

    <PageTitle v-else>
        Gestion de projet - Apikom - Forfaits - Créer un forfait
    </PageTitle>

    <PackageForm
        :package="props.package"
        :package-themes="props.packageThemes"
        :package-frequencies="props.packageFrequencies"
    />
</template>
